import APIServer from './APIServer'

export default class ArticleAPI extends APIServer { 
	async getById(id) { 
		return await super.get("/article/" + id)
	}

	async getStories(domain, {includeAll = false, excludeCategory=null, category=null, startDate=null} = {}) {
		var url = "/articles"
		if (domain !== undefined && domain !== null) { 
			url += "/" + domain
		} 

		url += `?include_all=${includeAll}` 
		if (category) {
			url += `&category=${category.toString()}`
		}
		if (excludeCategory) { 
			url += `&exclude_category=${excludeCategory.toString()}`
		}
		if (startDate) { 
			url += `&start_date=${startDate}`
		}
		return await super.get(url)
	}

}